import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M2 18V6a2 2 0 0 1 2-2h2.615a2 2 0 0 1 1.677.91L9 6h9a2 2 0 0 1 2 2v.001L19.907 8h-9.199a6 6 0 0 0-5.57 3.772l-2.883 7.206A2 2 0 0 1 2 18"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M4 20h13.207a2 2 0 0 0 1.824-1.18l2.7-6a2 2 0 0 0-1.044-2.664 2 2 0 0 0-.78-.156h-9.199a4 4 0 0 0-3.714 2.514z"
    }
  )
);
var SvgFolderOpen = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FolderOpen_default = SvgFolderOpen;

export { FolderOpen_default as default };
